import type { DefaultOptions } from '@apollo/client/core';

// defaultOptions del cliente admin, aparte para que los tests armen un cliente con la misma
// política (errorPolicy 'all': los errores GraphQL llegan en result.errors, no como excepción).
export const adminDefaultOptions: DefaultOptions = {
    watchQuery: {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
    },
    query: {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
    },
    mutate: {
        errorPolicy: 'all',
    },
};

// Devtools de Apollo apagadas siempre en el cliente admin. Activas, guardan en
// queryManager.mutationStore las variables de cada mutación mientras viva el cliente (incluido
// el PIN de una credencial de acceso local) y se las exponen a la extensión del navegador.
// Apollo las activa si globalThis.__DEV__ !== false, y el bundle de producción no lo define.
export const adminDevtools = { enabled: false };
